// src/services/rolesService.js
import axios from "../config/axiosConfig";

export const listRoles = () => axios.get("/api/roles");

export const createRole = (nombre, label) => axios.post("/api/roles", { nombre, label });
